module.exports = __webpack_public_path__ + "img/W@2x.4f66b11.jpg";